function MedicationLoader() {
  return (
    <div className="flex items-center gap-2">
      <div className="mb-2 h-16 w-16 animate-pulse rounded-lg bg-gray-400" />
      <div>
        <div className="flex items-center justify-between">
          <div className="mb-2 h-4 w-40 animate-pulse rounded-md bg-gray-400" />
        </div>
        <div className="mb-2 h-4 w-[90%] animate-pulse rounded-md bg-gray-400" />
      </div>
    </div>
  );
}

export default MedicationLoader;
